import PropTypes from 'prop-types';
import { Box } from '@qga/roo-ui/components';
import QantasHotelsLogo from './QantasHotelsLogo';
import { Column, Container, Row, SectionContainer, SmallSizeText } from '../primitives';

const PrintViewHeader = ({ bookingRef }) => (
  <SectionContainer>
    <Container>
      <Row>
        <Column>
          <QantasHotelsLogo />
        </Column>
        <Column>
          <Box textAlign="right">
            <SmallSizeText>Qantas Hotels booking confirmation</SmallSizeText>
            <SmallSizeText>
              Booking reference: <strong>{bookingRef}</strong>
            </SmallSizeText>
          </Box>
        </Column>
      </Row>
    </Container>
  </SectionContainer>
);

PrintViewHeader.propTypes = {
  bookingRef: PropTypes.string.isRequired,
};

export default PrintViewHeader;
